<app-web-push-subscribe-trigger></app-web-push-subscribe-trigger>
<router-outlet></router-outlet>
